import './SidebarMobile.css';
import './Sidebar.css';
import {Drawer,} from "@mui/material";
import * as React from "react";
import SidebarComponent from "./SidebarComponent";
import {sideBarListItemsClerk} from "./SideBarItems";

const SidebarMobile = () => {

    const [state, setState] = React.useState({
        left: false,
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({...state, [anchor]: open});
    };
    return (
        <div className="header-content">
            {['left'].map((anchor) => (
                <React.Fragment key={anchor}>
                    <div className="ic-menu" onClick={toggleDrawer(anchor, true)}/>
                    <Drawer
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                    >
                        <SidebarComponent sideBarListItems={sideBarListItemsClerk}/>
                    </Drawer>
                </React.Fragment>
            ))}
        </div>
    )
}
export default SidebarMobile;